import $ from 'domtastic'

import Dropdown from './Dropdown'




/* MENU
----------------------------------------------------------------------------------------------------*/

export default class Menu {

    constructor($el) {
        this.$els = {
            el   : $el,
            navs : $el.find('.subnav'),
        }


        this.initDropdowns(this.$els.navs)
    }


    initDropdowns($navs) {
        this.dropdowns = Array.from($navs).map($n => new Dropdown($n))
    }




    /* Handlers
    --------------------------------------------------------- */




    /* Actions
    --------------------------------------------------------- */




    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



